module.exports = __webpack_public_path__ + "img/bg_cybj.cfbe4a34.png";